module.exports = __webpack_public_path__ + "img/liumingxia.c321c5a7.jpeg";